import  React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { Grid, Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CancelFormComponent from './cancel';
import PropTypes from 'prop-types';
import fruitsVeg from '../../assets/images/fruitsVegBasket.jpg';
import { mapStateToProps } from '../../redux/reducers';
import { connect } from 'react-redux';




let languageCode = localStorage.getItem("selectedLanguage");
if (languageCode === null) {
  languageCode = "en-US";
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      body1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 19,
        color:"#212529 !important"
      },
    },
  });

 function CsaLandingComponent(props) {
    const navigate = useNavigate();
    const [language, setLanguage] = useState({});
    const [open, setOpen] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [reset, setReset] = useState(true);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") 
        return;
        setOpen(false);
        setShowForm(true);
        setReset(!reset);
    };
    const CenteredDialogTitle = ({ children }) => {
        const styles = {
          textAlign: 'center',
          paddingBottom:0
        };
        const borderStyles = {
            borderBottom: '2px solid #388557',
            display: 'inline-block',
            paddingBottom: '5px',
            fontSize:20.8
            // opacity:0.5
          };
      
        return <DialogTitle style={styles}> <span style={borderStyles}>{children}</span> </DialogTitle>;
      };

      CenteredDialogTitle.propTypes = {
        children: PropTypes.array,
    };

    useEffect(() => {
        setLanguage(props.signupLanguage)
    }, [props.signupLanguage]);


    const languageWidths = {
        'es-ES': "45rem",  // Spanish
        'pt-BR': "45rem",  // Portuguese
        'zh-Hans': "600px",  // Chinese
        'vi-VI': "45rem",  // Vietnamese
        'en-US': "600px",  // English (default)
      };

    return (
        <ThemeProvider theme={theme}>
            <Grid component={'main'} id='main-content' container sx={{ backgroundImage: `url(${fruitsVeg})`,minHeight:'450px',backgroundRepeat:"no-repeat",backgroundSize:"cover",justifyContent:"center",backgroundColor:"rgba(0, 0, 0, 0.121)", backgroundPosition:'center',flex:1}}>
            <Grid sx={{height:'230px'}} className='csa-landing-text'>
                <Box sx={{
                    width: languageWidths[languageCode] ,//languageCode === 'es-ES' ? '55rem' : 600,
                    color:"white",border:1,borderColor:"white", background:'rgb(0 0 0 / 75%)'}} >
                    <p style={{padding:"20px",fontSize:'20px',marginBottom:0 ,lineHeight:'1.2'}}>{language.landingImgTxt}</p>
                </Box>
            </Grid>
            <Grid container className='csa-landing' direction="column" alignItems="center" sx={{ paddingRight: 2, paddingLeft: 2, paddingBottom: 2, mt: languageCode === 'es-ES' ? -5 : -10 }}>
              {/* <Button id='csa-button' sx={{ backgroundColor: 'white', textTransform: 'none', color: 'black', width: '12%', marginBottom: 1, "&:hover": { backgroundColor: '#006E52', color: '#ffffff' } }} onClick={() => navigate('/dtafinder/csa-signup')} size='medium'>
              {language.EnrollCSA}
              </Button> */}
              <Button id='csa-button' sx={{ backgroundColor: 'white', textTransform: 'capitalize', color: 'black', width: '12%', marginBottom: 1, "&:hover": { backgroundColor: '#006E52', color: '#ffffff' } }} 
                onClick={() => window.open('https://www.mass.gov/service-details/how-to-participate-in-the-snap-csa-pilot', '_blank')}>
                {language.learnMore}
              </Button>
              <Button id='csa-button' onClick={handleClickOpen} sx={{ backgroundColor: 'white', textTransform: 'capitalize', color: 'black', width: '12%', marginBottom: 1, "&:hover": { backgroundColor: '#006E52', color: '#ffffff' } }}>
                {language.CancelCSA}
              </Button>
            </Grid>

        </Grid>
            <Dialog  maxWidth='lg' style={{zIndex:"999"}} open={open} TransitionComponent={Transition} keepMounted 
                onClose={handleClose}  PaperProps={{ style: { top: 0 } }} 
                aria-modal={false}
                // disableAutoFocus
                disableEnforceFocus
                // disableRestoreFocus  
                >
                <DialogTitle >
                <div style={{ textAlign: 'center', paddingBottom: 0 }}>
                    <span style={{ display: 'inline-block', paddingBottom: '5px', fontSize: 20.8 }}>
                        {language.cancelShareAgreement}
                    </span>
                </div>
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                            '&:focus-visible': {
                              outline: '2px solid black',   
                              outlineOffset: '2px',
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>          
                <DialogContent>
                       { open && ( 
                            <>
                                <CancelFormComponent showForm={showForm} setOpen={setOpen} setShowForm={setShowForm} setReset={setReset} reset={reset}/>                                
                            </>
                        )}                      
                </DialogContent>              
            </Dialog>
        </ThemeProvider>
    );
}
CsaLandingComponent.propTypes = {
  signupLanguage: PropTypes.object,
};

export default connect(
  mapStateToProps
)(CsaLandingComponent);